import { FC } from 'react'
import { useCart, useDialog } from 'src/shared/hooks'

import { NavIconsWrap, CartContainer, CartNumber, ShoppingCartIcon } from './styles'

const CartBtnV2: FC<{ modalReq: ReturnType<typeof useDialog> }> = (props) => {
  const { products } = useCart()
  const count = () => products.length

  const CartContent = CartContainer
  const CartNumberContainer = CartNumber

  return (
    <NavIconsWrap>
      <CartContent to={'/cart'}>
        <ShoppingCartIcon $isHome={true} $isScrolled={true} />
        <CartNumberContainer>{count()}</CartNumberContainer>
      </CartContent>
    </NavIconsWrap>
  )
}

export default CartBtnV2
